module.exports = __webpack_public_path__ + "img/success.be86a1d5.png";